import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25ef636c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-card-groupping-param" }
const _hoisted_2 = { class: "task__popover-title" }
const _hoisted_3 = { class: "task-card_user-data" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "task-card_scrollbar-content" }

import { computed, PropType } from 'vue';
import {
  TirPmPopover,
  PopoverPositionEnum,
  PopoverColorEnum,
  TirPmIconView,
  TirPmScrollbar,
  TirPmTooltipElement,
} from 'tir-components';
import { TaskParameterModel } from '@/components/task-parameter';
import { TaskPersonModel } from '@/components/tasks-kanban/models';
import { TaskParameter, TaskParameterTypeEnum } from '@/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-groupping-param',
  props: {
  /**Статус */
  status: { type: Object as PropType<TaskParameterModel> },
  /**Приоритет */
  priority: { type: Object as PropType<TaskParameterModel> },
  /**Тип */
  type: { type: Object as PropType<TaskParameterModel> },
  /**Список исполнителей */
  performers: { type: Array as PropType<Array<TaskPersonModel>> },
  /**Автор */
  author: { type: Object as PropType<TaskPersonModel> },
  /**Список тегов */
  tags: { type: Array as PropType<Array<TaskParameterModel>> },
},
  setup(__props) {

const props = __props;



/**Информация о параметре */
const parameterInfo = computed(() => {
  const params = [
    { Data: props.status, Type: TaskParameterTypeEnum.Status },
    { Data: props.priority, Type: TaskParameterTypeEnum.Priority },
    { Data: props.type, Type: TaskParameterTypeEnum.Type },
    { Data: props.tags, Type: TaskParameterTypeEnum.Tag },
  ];

  return params.find((param) => param.Data);
});

/**Показанный исполнитель */
const shownPerformer = computed<TaskPersonModel | undefined>(() => {
  if (!props.performers?.length) return;
  return props.performers[0];
});
/**Скрытые исполнители */
const hidePerformers = computed(() => props.performers?.slice(1));
/**Скрытые теги */
const hideTags = computed(() => props.tags?.slice(1));

/**Кол-во скрытых элементов */
const hideCount = computed(() => {
  let count = 0;
  if (props.tags) count = props.tags.length - 1;
  else if (props.performers) count = props.performers.length - 1;

  return Math.max(count, 0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (parameterInfo.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (Array.isArray(parameterInfo.value.Data))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (parameterInfo.value.Data.length)
                  ? (_openBlock(), _createBlock(_unref(TaskParameter), {
                      key: 0,
                      preview: "",
                      type: parameterInfo.value.Type,
                      data: parameterInfo.value.Data[0],
                      hideRemove: ""
                    }, null, 8, ["type", "data"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_unref(TaskParameter), {
                key: 1,
                preview: "",
                type: parameterInfo.value.Type,
                data: parameterInfo.value.Data,
                hideRemove: ""
              }, null, 8, ["type", "data"]))
        ], 64))
      : (__props.author)
        ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 1 }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(__props.author.FirstName) + " " + _toDisplayString(__props.author.MiddleName) + " " + _toDisplayString(__props.author.LastName), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(TirPmIconView), {
                size: 24,
                isRounded: "",
                colorCode: __props.author.NoPhotoColor,
                isBordered: false,
                imageLoadUrl: __props.author.ImageUrl
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.author.FirstName[0] + __props.author.LastName[0]), 1)
                ]),
                _: 1
              }, 8, ["colorCode", "imageLoadUrl"])
            ]),
            _: 1
          }))
        : (shownPerformer.value)
          ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
              key: shownPerformer.value.Id
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TirPmIconView), {
                  "is-rounded": "",
                  size: 24,
                  imageLoadUrl: shownPerformer.value.ImageUrl,
                  colorCode: shownPerformer.value.NoPhotoColor,
                  "is-bordered": false
                }, {
                  mainSlot: _withCtx(() => [
                    _createTextVNode(_toDisplayString(shownPerformer.value.FirstName[0] + shownPerformer.value.LastName[0]), 1)
                  ]),
                  _: 1
                }, 8, ["imageLoadUrl", "colorCode"])
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(shownPerformer.value.LastName) + " " + _toDisplayString(shownPerformer.value.FirstName) + " " + _toDisplayString(shownPerformer.value.MiddleName), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
    (hideCount.value > 0)
      ? (_openBlock(), _createBlock(_unref(TirPmPopover), {
          key: 3,
          isHideTriangle: false,
          "is-tooltip": "",
          color: _unref(PopoverColorEnum).Black,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              textContent: _toDisplayString(`+${hideCount.value}`),
              class: "task-card_circle"
            }, null, 8, _hoisted_4)
          ]),
          content: _withCtx(() => [
            _createVNode(_unref(TirPmScrollbar), {
              class: "task-card_scrollbar",
              "show-on-hover": true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (hidePerformers.value?.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(hidePerformers.value, (person) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: person.Id,
                          class: "task-card_hidden-users-content"
                        }, [
                          _createVNode(_unref(TirPmIconView), {
                            "is-rounded": "",
                            size: 24,
                            imageLoadUrl: person.ImageUrl,
                            colorCode: person.NoPhotoColor,
                            "is-bordered": false
                          }, {
                            mainSlot: _withCtx(() => [
                              _createTextVNode(_toDisplayString(person.FirstName[0] + person.LastName[0]), 1)
                            ]),
                            _: 2
                          }, 1032, ["imageLoadUrl", "colorCode"]),
                          _createTextVNode(" " + _toDisplayString(person.LastName) + " " + _toDisplayString(person.FirstName) + " " + _toDisplayString(person.MiddleName), 1)
                        ]))
                      }), 128))
                    : (hideTags.value?.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(hideTags.value, (tag) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: tag.Id,
                            class: "task-card_hidden-tags-content"
                          }, [
                            _createVNode(_unref(TaskParameter), {
                              preview: "",
                              type: _unref(TaskParameterTypeEnum).Tag,
                              data: tag,
                              hideRemove: ""
                            }, null, 8, ["type", "data"])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["color"]))
      : _createCommentVNode("", true)
  ]))
}
}

})